module.exports = __webpack_public_path__ + "img/svg.6ba2fb4a.svg";